import { Tabs, TabsContent, TabsList, TabsTrigger } from 'components/navigation/Tabs';
import ActiveSimulationsTab from 'features/simulations-v2/ActiveSimulationsTab';
import useGetScenarios from 'hooks/useGetScenarios';

import 'features/simulations-v2/_styles.scss';

const SimulationsV2Page = () => {
    const { scenarios, isLoading: scenariosIsLoading, isError: scenariosIsError } = useGetScenarios();

    return (
        <main className='SimulationsV2Page' data-testid='simulations-v2-page'>
            <h4 className='SimulationsV2Page__header'>Simulation 2.0</h4>
            <div className='SimulationsV2Page__content'>
                <Tabs defaultValue='active-simulations-tab' orientation='vertical'>
                    <TabsList aria-label='simulations tabs'>
                        <TabsTrigger value='active-simulations-tab'>
                            <span data-testid='simulations-v2-tab-active-simulations'>Active Simulations</span>
                        </TabsTrigger>
                        <TabsTrigger value='scenarios-tab'>
                            <span data-testid='simulations-v2-tab-scenarios'>Scenarios</span>
                        </TabsTrigger>
                    </TabsList>
                    <TabsContent value='active-simulations-tab'>
                        <ActiveSimulationsTab
                            scenarios={scenarios}
                            scenariosIsLoading={scenariosIsLoading}
                            scenariosIsError={scenariosIsError}
                        />
                    </TabsContent>
                    <TabsContent value='scenarios-tab'>
                        <div className='SimulationsV2Page__tabContent'>
                            <div className='SimulationsV2Page__tabHeader'>
                                <div>
                                    <h5 className='SimulationsV2Page__tabTitle'>Scenarios</h5>
                                    <p>Manage simulation scenarios</p>
                                </div>
                            </div>
                        </div>
                        <div />
                    </TabsContent>
                </Tabs>
            </div>
        </main>
    );
};

export default SimulationsV2Page;
